import { ChevronLeft, ChevronRight, Pin, Sun, Moon, Menu as MenuIcon } from 'lucide-react';

// Small icon helpers shared by the V3 bars. Chevrons point towards where the bar goes when it moves.
export const CollapseIcon = ({ side, open }) => {
  // Left bar: open -> arrow points left (collapse), strip -> points right (expand). Right bar is the mirror image.
  const pointsLeft = side === 'left' ? open : !open;
  return pointsLeft ? <ChevronLeft className="v3-i v3-i--sm" /> : <ChevronRight className="v3-i v3-i--sm" />;
};

export { Pin, Sun, Moon, MenuIcon };
